import en from './../../i18n/locales/en.json';

module.exports = {
  en: en
}



// WEBPACK FOOTER //
// ./src/model/i18n.js